export default __webpack_public_path__ + "static/media/illust-analysis@2x.16e506b8.png";